import React, { lazy, Suspense, useEffect } from "react";
import {
  Route,
  Redirect,
  Switch,
  withRouter,
  BrowserRouter,

} from "react-router-dom";

import { observer } from "mobx-react";
import { useStore } from "context/StoreContext";

import LoadingComponent from "components/atoms/LoadingComponent/LoadingComponent";
import BodyComponent from "components/atoms/BodyComponent/BodyComponent";
import PageWrapperComponent from "components/molecules/PageWrapperComponent/PageWrapperComponent"
import HeaderComponent from "components/atoms/HeaderComponent/HeaderComponent";
import { Toaster } from "react-hot-toast";
import FooterComponent from "components/atoms/FooterComponent/FooterComponent";

const HomePage = lazy(() => import("components/pages/HomePage"));
const ConfigPage = lazy(() => import("components/pages/ConfigPage"));
const QrCodeAllocatePage = lazy(() => import("components/pages/QrCodeAllocatePage"));
const ExternalCodeAllocatePage = lazy(() =>
  import("components/pages/ExternalCodeAllocatePage")
);
const SelectOrganizationPage = lazy(() => import("components/pages/SelectOrganizationPage"));
const SearchOrganizationFinalNodePage = lazy(() =>
  import("components/pages/SearchOrganizationFinalNodePage")
);
const SelectCustomerPage = lazy(() => import("components/pages/SelectCustomerPage"));
const AllocateContainerPage = lazy(() => import("components/pages/AllocateContainerPage"));
const AllocateContainerPreRegisteredPage = lazy(() =>
  import("components/pages/AllocateContainerPreRegisteredPage")
);
const AllocateContainerWithPhotoPage = lazy(() =>
  import("components/pages/AllocateContainerWithPhotoPage")
);
const CorreiosLoginPage = lazy(() =>
  import("components/pages/CorreiosLoginPage")
);
const CorreiosAllocatePage = lazy(() =>
  import("components/pages/CorreiosAllocatePage")
);
const PreRegisteredAllocatePage = lazy(() =>
  import("components/pages/PreRegisteredAllocatePage")
);

const QrCodeDeallocatePage = lazy(() => import("components/pages/QrCodeDeallocatePage"));
const DeallocateContainerPage = lazy(() => import("components/pages/DeallocateContainerPage"));

const QrCodeSeparatorModulePage = lazy(() => import("components/pages/QrCodeSeparatorModulePage"));
const ReverseListPage = lazy(() => import("components/pages/ReverseListPage"));
const ReverseContainerPage = lazy(() => import("components/pages/ReverseContainerPage"));

const ContainerTestsPage = lazy(() => import("components/pages/ContainerTestsPage"));
const CorreiosOptionsPage = lazy(() => import("components/pages/CorreiosOptionsPage"));

const QrCodeReturnPage = lazy(() => import("components/pages/QrCodeReturnPage"));
const QrCodePreRegisteredReturnPage = lazy(() => import("components/pages/QrCodePreRegisteredReturnPage"));
const ReturnContainerWithPhotoPage = lazy(() => import("components/pages/ReturnContainerWithPhotoPage"));
const PickUpReturnContainerPage = lazy(() => import("components/pages/PickUpReturnContainerPage"));
const SeparatorModulePage = lazy(() => import("components/pages/SeparatorModulePage"));
const ReturnListPage = lazy(() => import("components/pages/ReturnListPage"));

export default (props) => {

  return (
    <BrowserRouter>
      <HeaderComponent />
      <BodyComponent>
        <ConfigRoutes {...props} />
        <Toaster />
      </BodyComponent>
      <FooterComponent />
    </BrowserRouter>
  );
};

const ConfigRoutes = (
  withRouter(
    observer((props) => {
      return (
        <Suspense
          fallback={
            <PageWrapperComponent>
              <LoadingComponent />
            </PageWrapperComponent>
          }>
          <Switch>
            <Route exact path="/" render={() => <HomePage {...props} />} />
            <Route path="/config" render={() => <ConfigPage {...props} />} />
            <Route path="/container-tests" render={() => <ContainerTestsPage {...props} />} />
            <Route path="/correios-options" render={() => <CorreiosOptionsPage {...props} />} />

            <PrivateRoutes {...props} />
            <Redirect to="/" />
          </Switch>
        </Suspense>
      );
    })
  )
);

//rotas privadas que é possível acessar apenas com usuário logado.
const PrivateRoutes = (props) => {
  return (
    <React.Fragment>
      {/* ALLOCATION FLOW */}
      <Route
        exact
        path="/qr-code-allocate"
        render={() => <QrCodeAllocatePage {...props} />}
      />
      <Route
        exact
        path="/external-code-allocate"
        render={() => <ExternalCodeAllocatePage {...props} />}
      />
      <Route
        exact
        path="/pre-registered-allocate"
        render={() => <PreRegisteredAllocatePage {...props} />}
      />
      <Route
        exact
        path="/select-organization/organization/:uuidOrganization"
        render={() => <SelectOrganizationPage {...props} />}
      />
      <Route
        exact
        path="/search-organization-final-node/organization/:uuidOrganization"
        render={() => <SearchOrganizationFinalNodePage {...props} />}
      />
      <Route
        exact
        path="/select-customer/organization/:uuidOrganization"
        render={() => <SelectCustomerPage {...props} />}
      />
      <Route
        exact
        path="/allocate-container"
        render={() => <AllocateContainerPage {...props} />}
      />
      <Route
        exact
        path="/allocate-container-pre-registred/allocation/:uuidAllocation"
        render={() => <AllocateContainerPreRegisteredPage {...props} />}
      />
      <Route
        exact
        path="/allocate-container-with-photo"
        render={() => <AllocateContainerWithPhotoPage {...props} />}
      />

      {/* CORREIOS ALLOCATION FLOW */}
      <Route
        exact
        path="/correios-login"
        render={() => <CorreiosLoginPage {...props} />}
      />
      <Route
        exact
        path="/correios-allocate"
        render={() => <CorreiosAllocatePage {...props} />}
      />


      {/* DEALLOCATION FLOW */}
      <Route
        exact
        path="/qr-code-deallocate"
        render={() => <QrCodeDeallocatePage {...props} />}
      />

      <Route
        exact
        path="/deallocate-container/allocation/:uuidAllocation"
        render={() => <DeallocateContainerPage {...props} />}
      />


      {/* SEPARATOR MODULE */}
      <Route
        exact
        path="/qr-code-separator-module"
        render={() => <QrCodeSeparatorModulePage {...props} />}
      />
      <Route
        exact
        path="/separator-module"
        render={() => <SeparatorModulePage {...props} />}
      />

      {/* REVERSE FLOW */}


      <Route
        exact
        path="/reverse-list"
        render={() => <ReverseListPage {...props} />}
      />
      <Route
        exact
        path="/reverse-container-allocation/allocation/:uuidAllocation"
        render={() => <ReverseContainerPage {...props} />}
      />

      {/* RETURN FLOW */}
      <Route
        exact
        path="/qr-code-return"
        render={() => <QrCodeReturnPage {...props} />}
      />

      <Route
        exact
        path="/qr-code-pre-registered-return"
        render={() => <QrCodePreRegisteredReturnPage {...props} />}
      />

      <Route
        exact
        path="/return/allocation/:uuidAllocation"
        render={() => <ReturnContainerWithPhotoPage {...props} />}
      />

      <Route
        exact
        path="/return-list"
        render={() => <ReturnListPage {...props} />}
      />

      <Route
        exact
        path="/pick-up-return/allocation/:uuidAllocation"
        render={() => <PickUpReturnContainerPage {...props} />}
      />


    </React.Fragment>
  );
};
